module.exports = __webpack_public_path__ + "static/img/card3.d7c7e276.png";